import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
import moment from "moment";
var btoa = require("Base64").btoa;

function* fetchWarehousesPlan(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let id = value.value.id;

  try {
    const res = yield fetch(
      `${appConfig.ip}/warehsSubscrPlan?warehouse=${id}&status=active`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.FETCH_WAREHOUSESPLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WAREHOUSESPLAN_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchwarehouseSubList(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = value.value.item.warehouse.id;
  let fromDate = value.value.startDate;
  let toDate = value.value.endDate;
  try {
    const res = yield fetch(
      `${appConfig.ip}/warehsSubscriptn/dateFilter?warehouse=${id}&to=${toDate}&from=${fromDate}&status=active,pending`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_WAREHOUSESUBLIST_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WAREHOUSESUBLIST_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchsixMnthWarehsSub(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  let id = value.value.item.warehouse.id;
  let fromDate = value.value.startDate;
  let toDate = value.value.endDate;
  try {
    const res = yield fetch(
      `${appConfig.ip}/warehsSubscriptn/dateFilter?warehouse=${id}&to=${toDate}&from=${fromDate}&status=active,pending`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_SIXMNTH_WAREHOUSESUB_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_SIXMNTH_WAREHOUSESUB_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchWarehusPaymentmode() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/paymentMode?type=warehouse`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_WAREHOUSEPAYMENTMODE_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WAREHOUSEPAYMENTMODE_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchWarehouseProvider(params) {
  let id = params.item.user._id;
  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/licenseeProf/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_WAREHOUSESPROVIDER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_WAREHOUSESPROVIDER_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* WarehousesubscribeBankplan(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let data;

  if (user.role === "warehouse") {
    data = {
      orgId: value.value.orgId,
      userId: value.value.userId,
      warehsSubPlan: {
        name: value.item.name,
        warehouse: value.item.warehouse.id,
        amnt: value.item.amnt,
        validity: value.item.validity,
        minSellableUnit: value.item.minSellableUnit,
        noMinSellableUnit: value.item.noMinSellableUnit,
      },
      warehsSubPlanId: value.item.id,
      warehsId: value.item.user._id,
      warehsOrgId: value.item.orgId,
      validityFrom: value.startDate,
      validityTo: value.endDate,
      currency: value.item.warehouse.currency.id,
      amount: value.item.amnt,
      paymentType: value.value.paymentType,
      sellableUnit: value.item.minSellableUnit,
      txtnRefNo: value.value.txtnRefNo,
      status: "pending",
    };
  } else {
    data = {
      orgId: user.orgId,
      userId: user.id,
      warehsSubPlan: {
        name: value.item.name,
        warehouse: value.item.warehouse.id,
        amnt: value.item.amnt,
        validity: value.item.validity,
        minSellableUnit: value.item.minSellableUnit,
        noMinSellableUnit: value.item.noMinSellableUnit,
      },
      warehsSubPlanId: value.item.id,
      warehsId: value.item.user._id,
      warehsOrgId: value.item.orgId,
      validityFrom: value.startDate,
      validityTo: value.endDate,
      currency: value.item.warehouse.currency.id,
      amount: value.item.amnt,
      paymentType: value.value.paymentType,
      sellableUnit: value.item.minSellableUnit,
      txtnRefNo: value.value.txtnRefNo,
      status: "pending",
    };
  }

  try {
    const res = yield fetch(`${appConfig.ip}/warehsSubscriptn`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.WAREHOUSESUBSCRIBE_BANKPLAN_SUCCESS_ACTION,
        payload: resJSON,
      });
      if (user.role === "warehouse") {
        yield put(push("/warehouse/warehousesubscriptions"));
      } else {
        yield put(push("/mywarehousesubscription/subscriptions"));
      }

      yield toast.success(
        "Your subscription is successful and will be active once the payment is received at the runner end",
        {
          autoClose: 3000,
          className: "toastClass",
        }
      );
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.WAREHOUSESUBSCRIBE_BANKPLAN_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* Warehousesubscribeplan(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));

  let data;

  if (user.role === "warehouse") {
    data = {
      orgId: value.value.orgId,
      userId: value.value.userId,
      warehsSubPlan: {
        name: value.item.name,
        warehouse: value.item.warehouse.id,
        amnt: value.item.amnt,
        validity: value.item.validity,
        minSellableUnit: value.item.minSellableUnit,
        noMinSellableUnit: value.item.noMinSellableUnit,
      },
      warehsSubPlanId: value.item.id,
      warehsId: value.item.user._id,
      warehsOrgId: value.item.orgId,
      validityFrom: value.startDate,
      validityTo: value.endDate,
      currency: value.item.warehouse.currency.id,
      amount: value.item.amnt,
      paymentType: value.value.paymentType,
      sellableUnit: value.item.minSellableUnit,
    };
  } else {
    data = {
      orgId: user.orgId,
      userId: user.id,
      warehsSubPlan: {
        name: value.item.name,
        warehouse: value.item.warehouse.id,
        amnt: value.item.amnt,
        validity: value.item.validity,
        minSellableUnit: value.item.minSellableUnit,
        noMinSellableUnit: value.item.noMinSellableUnit,
      },
      warehsSubPlanId: value.item.id,
      warehsId: value.item.user._id,
      warehsOrgId: value.item.orgId,
      validityFrom: value.startDate,
      validityTo: value.endDate,
      currency: value.item.warehouse.currency.id,
      amount: value.item.amnt,
      paymentType: value.value.paymentType,
      sellableUnit: value.item.minSellableUnit,
      razorpayOrderId: value.response.razorpay_order_id,
    };
  }

  try {
    const res = yield fetch(`${appConfig.ip}/payment/razorPayVerfiy`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        razorPaymentId: value.response.razorpay_payment_id,
        razorpayOrderId: value.response.razorpay_order_id,
        signature: value.response.razorpay_signature,
      }),
    });
    if (!res) {
      throw res;
    } else {
      let resJSON = yield res.json();

      if (resJSON.signatureIsValid === true) {
        const res = yield fetch(`${appConfig.ip}/warehsSubscriptn`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify(data),
        });
        if (!res) {
          throw res;
        } else {
          let resJSON = yield res.json();
          yield put({
            type: actionTypes.CREATE_INVOICE_ACTION,
          });
          let keyword =
            user.role === "warehouse"
              ? [value.value.orgName, value.item.orgName]
              : [user.orgName, value.item.user.orgName];
          let totalAmount =
            value.item.amnt + value.item.gst + value.item.gatewayCharge;
          console.log("-----------totalAmount-----", totalAmount);
          const invoicedata = {
            warehsSubscrptnId: resJSON.id,
            subscriptnNo: resJSON.no,
            creator: value.item.user._id,
            // reciever: user.id,
            // recieverOrgId: user.orgId,
            reciever: resJSON.userId,
            recieverOrgId: resJSON.orgId,
            creatorOrgId: value.item.orgId,
            type: "warehouse",
            currency: value.item.warehouse.currency.id,
            amount:value.item.amnt,
            gatewayCharge: value.item.gatewayCharge
              ? value.item.gatewayCharge
              : 0,
            gst: value.item.gst ? value.item.gst : 0,
            keyword: keyword,
            status: "paid",
          };
          console.log("----------------", invoicedata);

          try {
            const res = yield fetch(`${appConfig.ip}/invoice`, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
              body: JSON.stringify(invoicedata),
            });
            if (!res.ok) {
              let errJSON = {};
              try {
                errJSON = yield res.json();
              } catch {}
              throw Object.assign(res, errJSON);
            } else {
              let resJSON = yield res.json();

              yield put({
                type: actionTypes.CREATE_PAYMENT_ACTION,
              });

              console.log("----------------", resJSON);

              const paymentdata = {
                warehsSubscrptnId: resJSON.warehsSubscrptnId,
                subscriptnNo: resJSON.subscriptnNo,
                invoiceId: resJSON.id,
                invcNo: resJSON.no,
                reciever: value.item.user._id,
                // userId: user.id,
                // orgId: user.orgId,
                userId: resJSON.reciever,
                orgId: resJSON.recieverOrgId,
                receiverOrgId: value.item.orgId,
                status: "paid",
                paymentType: value.value.paymentType,
                type: "warehouse",
                currency: value.item.warehouse.currency.id,
                amount: totalAmount,
                razorPaymentId: value.response.razorpay_payment_id,
              };

              try {
                const res = yield fetch(`${appConfig.ip}/payment`, {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
                  body: JSON.stringify(paymentdata),
                });
                if (!res.ok) {
                  let errJSON = {};
                  try {
                    errJSON = yield res.json();
                  } catch {}
                  throw Object.assign(res, errJSON);
                } else {
                  let resJSON = yield res.json();

                  yield put({
                    type: actionTypes.CREATE_PAYMENT_SUCCESS_ACTION,
                    payload: resJSON,
                  });
                  if (user.role === "warehouse") {
                    yield put(push("/warehouse/warehousesubscriptions"));
                  } else {
                    yield put(push("/mywarehousesubscription/subscriptions"));
                  }
                  yield toast.success(
                    "Your subscription to the warehouse is now active",
                    {
                      autoClose: 3000,
                      className: "toastClass",
                    }
                  );
                }
              } catch (err) {
                yield put({
                  type: actionTypes.CREATE_PAYMENT_FAIL_ACTION,
                  error: err,
                });
              }

              yield put({
                type: actionTypes.CREATE_INVOICE_SUCCESS_ACTION,
                payload: resJSON,
              });
            }
          } catch (err) {
            yield put({
              type: actionTypes.CREATE_INVOICE_FAIL_ACTION,
              error: err,
            });
          }

          yield put({
            type: actionTypes.WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION,
            payload: resJSON,
          });
        }
      } else {
        yield toast.error("Payment Failed", {
          autoClose: 3000,
          className: "toastClass",
        });
      }
    }
  } catch (err) {
    yield put({
      type: actionTypes.WAREHOUSESUBSCRIBE_PLAN_FAIL_ACTION,
      error: err,
    });
  }
}

function* fetchOtherUsers(value) {
  const token = localStorage.getItem("token");
  let page = (value.value && value.value.page) || 1;
  try {
    const res = yield fetch(
      `${appConfig.ip}/users?limit=5&role=shipper-enterprise,runner&page=${page}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_OTHERUSERS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_OTHERUSERS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* createRazorpayOrder(action) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/subscriptn/createRazorpayOrder`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ amount: action.payload }),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.CREATE_RAZORPAYORDER_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.CREATE_RAZORPAYORDER_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchAppconfig() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/appConfig`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_APPCONFIG_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_APPCONFIG_FAIL,
        error: err,
      });
    } else {
    }
  }
}

export function* UserPlanSbsrptnWarehseActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_WAREHOUSESPLAN_INIT_ACTION,
    fetchWarehousesPlan
  );
  yield takeEvery(
    actionTypes.FETCH_WAREHOUSESUBLIST_INIT_ACTION,
    fetchwarehouseSubList
  );
  yield takeEvery(
    actionTypes.FETCH_WAREHOUSEPAYMENTMODE_INIT_ACTION,
    fetchWarehusPaymentmode
  );
  yield takeEvery(
    actionTypes.FETCH_WAREHOUSESPROVIDER_INIT_ACTION,
    fetchWarehouseProvider
  );
  yield takeEvery(
    actionTypes.WAREHOUSESUBSCRIBE_BANKPLAN_ACTION,
    WarehousesubscribeBankplan
  );
  yield takeEvery(
    actionTypes.WAREHOUSESUBSCRIBE_PLAN_ACTION,
    Warehousesubscribeplan
  );
  yield takeEvery(actionTypes.FETCH_OTHERUSERS_INIT_ACTION, fetchOtherUsers);
  yield takeEvery(actionTypes.CREATE_RAZORPAYORDER_ACTION, createRazorpayOrder);
  yield takeEvery(
    actionTypes.FETCH_SIXMNTH_WAREHOUSESUB_INIT_ACTION,
    fetchsixMnthWarehsSub
  );
  yield takeEvery(actionTypes.FETCH_APPCONFIG_INIT, fetchAppconfig);
}
